export class Cias {

    public alias(cia: number): string {

        let alias = "";

        switch (cia) {

            case 1:
                alias = "CHUBB";
                break;
            case 3:
                alias = "AIG";
                break;
            case 7:
                alias = "ANA";
                break;
            case 14:
                alias = "HDI";
                break;
            case 16:
                alias = "GSeguros";
                break;
            case 18:
                alias = "GNP";
                break;
            case 20:
                alias = "AXA";
                break;
            case 22:
                alias = "Mapfre";
                break;
            case 29:
                alias = "Qualitas";
                break;
            case 31:
                alias = "Afirme";
                break;
            case 33:
                alias = "ATLAS";
                break;
            case 35:
                alias = "Banorte";
                break;
            case 44:
                alias = "Zurich";
                break;
            case 49:
                alias = "Primero";
                break;
            case 88:
                alias = "Sura";
                break;
            default:
                alias = "";
                break;
        }

        return alias;
    }
}

export enum Cia {
    CHUBB = 1,
    HDI = 14,
    GNP = 18,
    MAPFRE = 22,
    QUALITAS = 29,
    AFIRME = 31,
    PRIMERO = 49,
    AXA = 20
}